import { useTranslation } from 'next-i18next';
import BeddingSectionButton from './BeddingSectionButton';
import BeddingSectionStack from './BeddingSectionStack';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import { useEffect, useRef, useState } from 'react';
import classnames from 'classnames';

const BeddingSection = () => {
  const { t: tCategory } = useTranslation('', { keyPrefix: '$local.$category' });
  const { t: tCommon } = useTranslation('', { keyPrefix: '$common' });
  const { t: tLocal } = useTranslation('', { keyPrefix: '$local' });

  const { t: tBedding } = useTranslation('', { keyPrefix: '$pages.$home.$beddingSection' });
  const buttons = ['pillow', 'linen', 'blanket', 'topper'];
  const [currentButton, setCurrentButton] = useState(buttons[0]);
  const [lastButton, setLastButton] = useState(buttons[0]);
  const [tl, setTl] = useState(gsap.timeline());
  const stackContainer = useRef(null);
  const { contextSafe } = useGSAP({ scope: stackContainer });

  useEffect(() => {
    contextSafe(() => {
      gsap.set(`.stack-item:not(.${currentButton})`, { y: -500 });
    })();
  }, []);

  const onHover = (buttonID: string) => {
    setLastButton(currentButton);
    setCurrentButton(buttonID);
    contextSafe(() => {
      gsap.set(`.svg-overlay.${buttonID}`, { visibility: 'visible', alpha: 0.5 });
    })();
  };
  const clearOverlay = () => {
    contextSafe(() => {
      gsap.set(`.svg-overlay`, { visibility: 'hidden', alpha: 0 });
    })();
  };
  useGSAP(
    () => {
      if (currentButton === lastButton) return;
      if (tl.isActive()) {
        tl.progress(1);
      }
      tl.set(`.stack-item.${currentButton}`, { y: -500 })
        .set(`.stack-item.${lastButton}`, { y: 0 })
        .to(`.stack-item.${lastButton}`, { y: 500, duration: 0.4, ease: 'back.in' })
        .set(`.stack-item.${lastButton}`, { y: -500 })
        .to(`.stack-item.${currentButton}`, {
          y: 0,
          duration: 1,
          ease: 'back',
        });
    },
    { scope: stackContainer, dependencies: [currentButton] },
  );

  return (
    <section className="base-section bedding-section hp-section" ref={stackContainer}>
      <div className="desktop-viewport">
        <div className="content-section">
          <h2>{tBedding('title')}</h2>
        </div>
        <div className="bedding-row">
          <div className="bedding-img">
            {buttons.map(button => (
              <img
                key={button}
                src={`/images/homePage/beddingSection/hp-bedding-overlay-${button}.svg`}
                alt={`${button}: ${tLocal('overlay')}`}
                className={classnames('svg-overlay', button)}
                loading="lazy"
                decoding="async"
                fetchPriority="low"
              />
            ))}
            <picture>
              <source srcSet="/images/homePage/fill.gif" media="(max-width: 801px)" />
              <img
                src="/images/homePage/beddingSection/courtyard-marriott-bedding.webp"
                alt={tCategory('linens')}
                width={1323}
                height={677}
                loading="eager"
                decoding="async"
                fetchPriority="low"
              />
            </picture>
            <ul className="bedding-buttons">
              {buttons.map(button => (
                <BeddingSectionButton
                  key={button}
                  buttonID={button}
                  onHover={() => onHover(button)}
                  onHoverEnd={clearOverlay}
                />
              ))}
            </ul>
          </div>
          <div className="stack stack">
            <div className="bedding-block">
              {buttons.map(stack => (
                <BeddingSectionStack key={stack} stackID={stack} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default BeddingSection;
